import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=26991630&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26991630')) {
      api.createRecord('26991630', component.options)
    } else {
      api.reload('26991630', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=26991630&", function () {
      api.rerender('26991630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v3U4B2qSjxGw/JS/comp/FavElement.vue"
export default component.exports